export default class ProductId {
  productCode: string
  clientCode: string
  coverageCode?: string

  constructor(data: any) {
    this.productCode = data.productCode
    this.clientCode = data.clientCode
    this.coverageCode = data.coverageCode ?? undefined
  }
}
